import { csx } from '@vtex/admin-ui'

const section = {
  section: csx({ ':not(:last-child)': { marginBottom: '$space-20' } }),
  content: csx({
    flexDirection: 'column',
    marginTop: '$space-6',
    rowGap: '$space-4',
    width: 'full',
    '[data-fluid]': {
      '> *': {
        width: 'full',
      },
    },
  }),
}

export default section
